import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrlPipe } from '../../../../../utils/brl.pipe';
import { OrcamentoAgrupado } from '../../../../../utils/historico-paciente.util';

@Component({
  selector: 'app-hp-orcamentos',
  standalone: true,
  imports: [CommonModule, BrlPipe],
  templateUrl: './hp-orcamentos.component.html',
  styleUrl: './hp-orcamentos.component.scss',
})
export class HpOrcamentosComponent {
  @Input() orcamentos: OrcamentoAgrupado[] = [];
  abertos = new Set<number>();

  alternar(nr: number): void {
    if (this.abertos.has(nr)) this.abertos.delete(nr); else this.abertos.add(nr);
  }
}
